import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITerminal, TerminalAdministrationService } from '@shared/services/terminalAdministration.service';

@Component({
	selector: 'app-delete-terminal',
	templateUrl: './delete-terminal.component.html',
	styleUrls: ['./delete-terminal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteTerminalComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public terminal: ITerminal,
		public dialogRef: MatDialogRef<DeleteTerminalComponent>,
		private terminalService: TerminalAdministrationService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';
		this.terminalService.deleteTerminalById(this.terminal.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
